module.exports = __webpack_public_path__ + "img/stella_schaller.12a77edd.jpg";